import { RowTripPatternStopDto } from "@/dtos";
import { TripPatternStop } from "@/entities";
import { getTripPatternCheckpointTypeOption } from "@/helpers/options";

import { convertSecondsToTime } from "@/helpers/utilities";
import { MapCheckpoint } from "@/ui/components/maps/common/interfaces/map-checkpoint";
import { MapLine } from "@/ui/components/maps/common/interfaces/map-line";

export const formatRowTripPatternStopDto = (tripPatternStops: TripPatternStop[]): RowTripPatternStopDto[] => {
    return tripPatternStops.map((x) => {
        const row: RowTripPatternStopDto = {
            ...x,
            type_label: getTripPatternCheckpointTypeOption(x.type).label,
            time_between_stops_label: convertSecondsToTime(x.time_between_stops),
            stop_label: (x.stop?.name) ? x.stop.name : 'S/N',
            active: (x.is_active) ? 'Activo' : 'Inactivo',
        }

        return row;
    });
}

export const formatStopCoordsToMap = (rows: RowTripPatternStopDto[]) => {
    const mapCoordinates: MapCheckpoint[] = [];
    rows.sort((a, b) => a.order - b.order);
    for (const row of rows) {
        const mapCoordinate: MapCheckpoint = {
            name: row.stop.name,
            coordinate: [row.stop.longitude, row.stop.latitude],
            isPrimaryColor: row.is_active,
            radio: row.stop.radio ?? 10
        }
        mapCoordinates.push(mapCoordinate);
    }

    const mapLine: MapLine = {
        identification: "Line 1",
        coordinates: mapCoordinates
    };

    return [mapLine];
}

